import { QueryFunctionContext } from '@tanstack/react-query';
import { baseQuery } from '../baseQuery';
import { TechnicianSkillSet } from 'types';

type getAssignableTechnicianSkillSetsParams = {
  technicianId?: string;
};

export const getAssignableTechnicianSkillSets = async ({
  queryKey,
}: QueryFunctionContext<[string, getAssignableTechnicianSkillSetsParams]>): Promise<TechnicianSkillSet[]> => {
  const [, params] = queryKey;
  const { data } = await baseQuery(`technicians/${params.technicianId}/skill-sets/available`);

  return data as TechnicianSkillSet[];
};
